export default "__VITE_ASSET__DAgcxbZD__"